<div class="box-paperless last roboto-r text-center m-top-paper-m" *ngIf="this.viewPaper==0">
  <div class="basicrow roboto-b f-bmed left-paper-m">
    <img class="digfctr-b" width="100%" src="../../assets/images/fact-dig.png">
  </div>
  <div class="basicrow m-top m-bot-paper right-paper-m">
    <div>
      <div class="f-reg f-reg pull-left alg-l">
        <div class="basicrow f-bmed roboto-b text-justify" [hidden]="this.paperless != false">
          &#191;Te gustar&iacute;a conservar el ambiente? Suscr&iacute;bete al servicio de Factura Electr&oacute;nica.
        </div>
        <div class="basicrow f-bmed roboto-b text-justify" [hidden]="this.paperless != true">
          Gracias, ya estas suscrito a Factura Electrónica.
        </div>
      </div>
      <div [hidden]="paperless!=true" class="pad-zero pull-left m-paper-t">
        <div class="autocont f-green-i txtSusc1">
          <span class="f-newfdig">Suscrito a Factura Electr&oacute;nica</span>
        </div>
        <div class="autocont nofloat pad-left paper-green-size txtSusc2" style="margin-left: 5%">
          <img class="fdig-check" width="44px" src="../../assets/images/fact-dig-check.png">
        </div>
      </div>
      <div class="col-xs-12  left-p" [hidden]="paperless==true">
        <label class="switch dig-def-i pull-left paper-mod-switch">
          <input type="checkbox">
          <span class="slider" (click)="updatepaperless()"></span>
        </label>
      </div>
    </div>
  </div>
</div>
<!-- view home -->
<div class="dashdirect-digf" *ngIf="this.viewPaper==1">
  <img class="digf-def-i" width="100%" src="../../assets/images/fact-dig.png">
  <!--[INIT ESTADO SUBSCRITO]-->
  <div [hidden]="paperless!=true" class="autocont nofloat alrd-mleft">
    <div class="autocont f-green-i vcenter mr-p">
      <div class="tabcell">
        <span class="f-newfdig">Suscrito a Factura Electr&oacute;nica</span>
      </div>
    </div>
  </div>
  <div [hidden]="paperless!=true" class="autocont nofloat">
    <div class="autocont vcenter">
      <div class="tabcell">
        <img class="fdig-check" width="100%" src="../../assets/images/fact-dig-check.png">
      </div>
    </div>
  </div>
  <!--[END ESTADO SUBSCRITO]-->
  <!-- [INIT ESTADO NO SUBSCRITO] -->
  <div [hidden]="paperless==true" class="autocont nofloat m-septrt">
    <div class="autocont vcenter">
      <div class="tabcell">
        Factura Electr&oacute;nica:
      </div>
    </div>
  </div>
  <div class="col-xs-12  left-p" [hidden]="paperless==true">
    <label class="switch dig-def-i pull-left paper-mod-switch-b">
      <input type="checkbox">
      <span class="slider" (click)="updatepaperless()"></span>
    </label>
  </div>
  <!-- [INIT ESTADO NO SUBSCRITO] -->
</div>
<!--fin view home -->